import {nknTimes} from "./nknTimes";

const apiBaseUrl = 'https://api.nkn.org'
const cmsBaseUrl = 'https://api.nkn.org/api/cms'


function callApi(url, callback, failed) {
  $.getJSON(url)
    .done(function (data) {
      if(callback instanceof Function) {
        let responseTime = nknTimes.responseTime(data["Timestamp"])

        if("NKNDataPump.v1" === data["ApiVersion"]) {
          data = data["Data"]
        }

        data = {
          "data": data,
          "responseTime": responseTime
        }

        callback(data)

      }
    })
    .fail(function (data) {
      if(failed instanceof Function) {
        failed(data)
      }
    })

  return new Date().getTime()
}

function getGeoList(placeholder, callback, failed) {
  return callApi(`${apiBaseUrl}/v1/geo/list`, callback, failed)
}

function getGeoSummry(placeholder, callback, failed) {
  return callApi(`${apiBaseUrl}/v1/geo/summary`, callback, failed)
}

function getNews(callback, failed) {
  return callApi(`${cmsBaseUrl}/news?page=1`, callback, failed)
}

export default {
  getGeoList,
  getGeoSummry,
  getNews,
}


// WEBPACK FOOTER //
// ./src/tasks/nknServerApi.js